import { KeyValue } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/_helpers';

@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.css'],
})
export class ChartsComponent implements OnInit {
  loadingSlides = true;
  gVenituriOperationale = [];
  charts = {};

  constructor(private router: Router, private globals: Globals) {}

  ngOnInit(): void {
    this.charts = JSON.parse(localStorage.getItem('charts'));
    // console.log('charts', this.charts);
    // for(const o of (charts)){
    //   console.log(o)
    // }
  }

  goToCompare(): void {
    // Retrieve checkCompare from localStorage and set to globals (same as files.component.ts)
    const storedData = localStorage.getItem("checkCompare");
    if (storedData) {
      this.globals.checkCompare = JSON.parse(storedData);
    }
    this.router.navigate(['/comparatii']);
  }

  public optionsChart = {
    colors: [
      '#28B5B5',
      '#8FD9A8',
      '#D2E69C',
      '#C996CC',
      '#916BBF',
      '#4B778D',
      '#3D2C8D',
      '#1C0C5B',
    ],
    isStacked: false,
    is3D: false,
    fontSize: 14,
    lineWidth: 5,
    pointSize: 10,
    role: 'annotationText',
    chartArea: {top:'5%', left:'5%', height:'85%', width:'100%'},
    annotations: {
      textStyle: {
        fontSize: 18,
        bold: true,
      }
    },
    legend: { position: 'none' },
    };
  // Preserve original property order
  originalOrder = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    return 0;
  };
}
